// src/project/data/triggers/markAllNotificationsRead.js
// POST /message/mark/all/read?group=ultraxeno
// Body: { userId }
import { buildActionUrl, getUserId } from '../config/apiConfig'

export default {
  postUrl() {
    return buildActionUrl('/message/mark/all/read')
  },
  format() {
    return {
      userId: getUserId(),
    }
  },
  parse(raw = {}) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Erreur lors du marquage global',
        data: null,
      }
    }
    return {
      statusCode: 200,
      message: raw?.message || 'Toutes les notifications marquées comme lues',
      data: null,
    }
  },
}
